export enum OrganizationType {
  OPERATOR_TYPE_MANUFACTURER_IMPORTER = 1,
  OPERATOR_TYPE_OTHER = 2,
  OPERATOR_TYPE_SERVICE_PROVIDER = 3,
  OPERATOR_TYPE_DENTSU_ORGANIZATION = 4,
  OPERATOR_TYPE_HMRC = 5
}
